import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

export type ConfirmClearDialogProps = {
  open: boolean;
  handleClose: () => void;
  handleClick: () => void;
  enviroment: string;
  queue: string;
  loading?: boolean;
};

export const ConfirmClearDialog = (props: ConfirmClearDialogProps) => {
  const { open, handleClose, handleClick, queue, enviroment, loading } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-clear-title"
    >
      <DialogTitle id="confirm-clear-title">Confirm Clear Queue</DialogTitle>
      <DialogContent>
        <DialogContentText data-testid="dialog-content-text">
          Do you really want to clear the <strong>{queue}</strong> queue on{' '}
          <strong>{enviroment}</strong> enviroment?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleClick}
          disabled={loading}
          data-testid="confirm-button"
        >
          <Box
            sx={{ display: 'flex', minWidth: '97px', justifyContent: 'center' }}
          >
            {!loading && 'Confirm'}
            {loading && <CircularProgress color="inherit" size={22} />}
          </Box>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
